import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-instagram-logo',
  templateUrl: './instagram-logo.component.html',
  styleUrls: ['./instagram-logo.component.scss']
})
export class InstagramLogoComponent {

  @Input()
  enable = false;

  constructor() {
  }

}
